module.exports = __webpack_public_path__ + "static/img/shotcutmenu.78e59a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shotcutmenu.png
// module id = ZhyZ
// module chunks = 1